import isObjEmpty from '../../../../utils/helpers/isObjectEmpty';

export function isGeorgia(value) {
  return +value === 268;
}

export function isCity(value) {
  return +value === 1;
}

export function isVillage(value) {
  return +value === 2;
}

export function isGeoCode(code) {
  return +code === 268;
}

export const cityOrVillage = [
  {
    referenceId: 1,
    referenceNameEn: 'City',
    referenceNameGe: 'ქალაქი',
  },
  {
    referenceId: 2,
    referenceNameEn: 'Village',
    referenceNameGe: 'სოფელი',
  },
];

export const fieldNames = {
  BIRTH_COUNTRY: 'birthCountry',
  BIRTH_CITY: 'birthCity',
  CITY: 'city',
  EMAIL: 'email',
  MOBILE_NUMBER:'mobile_number',
  COUNTRY_CODE: 'countryCode',
  COUNTRY: 'country',
  CITY_VILLAGE: 'cityVillage',
  APARTMENT_NUMBER: 'apartmentNumber',
  HOME_NUMBER: 'homeNumber',
  STREET: 'street',
  DUAL_CITIZENSHIP: 'dualCitizenship',
  IS_ACTUAL_ADDRESS: 'isActualAddress',
  VILLAGE: 'village',
  LEGAL_ADDRESS: 'legal_address',
  ACTUAL_ADDRESS: 'actual_address',
  SEX: 'sex',
  DUAL_CITIZENSHIP_COUNTRY: 'dual_citizenshipt_country',
};

export const PEP_RELATED_OPTIONS = {
  yesOptions: ['1', '2', '3', '4'],
  noOptions: ['0']
}

// function returns true if we have address.actualAddress.country and address.Actualaddress.homeNUmber
export function doWeHaveActualAddress(address) {
  const { [fieldNames.ACTUAL_ADDRESS]: actualAddress } = address;
  if (!actualAddress) return false;
  const { [fieldNames.COUNTRY]: country } = actualAddress;

  return !!country;
}

// gets valuee from obj with string key (obj['value.value'])
export function getNestedValue(obj, string) {
  if (!string) {
    return null;
  }
  const values = string.split('.');
  let result = { ...obj };

  for (let i = 0; i < values.length; i++) {
    if (!result || isObjEmpty(result)) return '';
    result = result[values[i]] || '';
  }
  return result;
}

export function isContentGeorgian(lang) {
  return lang === 'ka';
}

export function withNameSpace(namespace, fieldName ) {
  return namespace ? `${namespace}.${fieldName}` : fieldName;
}

export function withTwoNameSpaces(namespace, secondName, fieldName ) {
  return namespace ? `${namespace}.${secondName}.${fieldName}` : fieldName;
}

export function moveGeorgiaUp(data) {
  return data.sort(({ referenceId }) => {
    if (isGeorgia(referenceId)) {
      return -1;
    }
    return 1;
  });
}


